import { TOTAL_TILES } from '../types/game-state.ts';
import type { Tile } from '../types/tile.ts';
import { type RNG, shuffle } from './random.ts';

export function createTilePool(rng: RNG): Tile[] {
  const numbers = Array.from({ length: TOTAL_TILES }, (_, i) => i + 1);
  const shuffled = shuffle(numbers, rng);
  return shuffled.map((n) => ({
    id: `t-${n}`,
    number: n,
    face: 'DOWN',
    resolvedNumber: null,
  }));
}
